/**
 * Decouples "something useful just happened" from the newsletter dialog.
 *
 * Callers fire `promptNewsletter()` after the visitor got value (a generated CV,
 * a finished article); `CommonNewsletterDialog` listens for the event and
 * decides whether it is eligible to open (not subscribed, not shown before).
 */
export const NEWSLETTER_PROMPT_EVENT = 'newsletter:prompt'

export interface NewsletterPromptDetail {
  /** Fills the address in, e.g. the one from the CV just downloaded. Still sent by the visitor. */
  email?: string | null
  /** The account-less CV behind the prompt; the follow-up e-mails review and link it. */
  generationId?: string | null
}

export function useNewsletterPrompt() {
  function promptNewsletter(delayMs = 0, detail: NewsletterPromptDetail = {}) {
    if (!import.meta.client) return
    const fire = () => window.dispatchEvent(new CustomEvent<NewsletterPromptDetail>(NEWSLETTER_PROMPT_EVENT, { detail }))
    if (delayMs > 0) {
      setTimeout(fire, delayMs)
    } else {
      fire()
    }
  }

  return { promptNewsletter }
}
